import axios from 'axios';

const REGISTER_BASE_URL = process.env.REACT_APP_FCM_API_URL || process.env.REACT_APP_API_URL;
const server = axios.create({
    baseURL: REGISTER_BASE_URL,
    headers: { 'Content-Type': 'application/json' }
});

const REGISTER_PATH = process.env.REACT_APP_FCM_REGISTER_PATH || '/notification/device-token';
const HEARTBEAT_PATH = process.env.REACT_APP_FCM_HEARTBEAT_PATH || `${REGISTER_PATH}/heartbeat`;
const BACKGROUND_PATH = process.env.REACT_APP_FCM_BACKGROUND_PATH || `${REGISTER_PATH}/background`;
const UNREGISTER_PATH = process.env.REACT_APP_FCM_UNREGISTER_PATH || `${REGISTER_PATH}/unregister`;
const SIGNOUT_PATH = process.env.REACT_APP_FCM_SIGNOUT_PATH || `${REGISTER_PATH}/signout`;

export class MobilePushFetchAPI {

    static async registerDeviceToken(data, token) {
        const res = await server(REGISTER_PATH, {
            method: 'post',
            headers: { 'x-access-token': token },
            data
        });
        return res;
    }

    static async unregisterDeviceToken(data, token) {
        const res = await server(UNREGISTER_PATH, {
            method: 'post',
            headers: { 'x-access-token': token || '' },
            data
        });
        return res;
    }

    static async heartbeatDeviceToken(data, token) {
        const res = await server(HEARTBEAT_PATH, {
            method: 'post',
            headers: { 'x-access-token': token || '' },
            data
        });
        return res;
    }

    static async backgroundDeviceToken(data, token) {
        const res = await server(BACKGROUND_PATH, {
            method: 'post',
            headers: { 'x-access-token': token || '' },
            data
        });
        return res;
    }

    static async signoutDeviceToken(data, token) {
        const res = await server(SIGNOUT_PATH, {
            method: 'post',
            headers: { 'x-access-token': token || '' },
            data
        });
        return res;
    }
}
